import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ImageWithShadow } from '../ImageWithShadow';
import { colors } from '../../styles';
import styles from './ImagesWithShadowList.styles';

const ImagesWithShadowList = ({ images: { first: imagesFromFirsSection } }) => (
  <div css={styles}>
    <div className="images">
      {imagesFromFirsSection.map((image, index) => (
        <div key={uuidv4()}>
          <ImageWithShadow image={image} shadowColor={colors.lightGray} position={index > 0 ? 'right' : 'left'} />
        </div>
      ))}
    </div>
  </div>
);

export default ImagesWithShadowList;
